module.exports = __webpack_public_path__ + "static/media/fullscreen.0b868e0e.svg";